import { useTranslation } from "react-i18next";
import { BadgeDollarSign } from "lucide-react";

// شارة ظاهرة أعلى الشروط في نسخة المتاجر: التطبيق مجاني ولا مشتريات داخله (آبل 3.1.3(c)).
export const NoPurchaseBadge = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-6 rounded-2xl p-4 shadow-neu-in" data-testid="no-purchase-badge">
      <p className="flex items-center gap-2 text-sm font-black text-primary">
        <BadgeDollarSign className="h-5 w-5" /> {t("legal.noIapTitle")}
      </p>
      <p className="mt-2 text-xs leading-6 text-muted-foreground">{t("legal.noIapBody")}</p>
    </div>
  );
};
